
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top-airbnb-markets/[[...page]]",
      function () {
        return require("private-next-pages/top-airbnb-markets/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top-airbnb-markets/[[...page]]"])
      });
    }
  